import { routes, useCurrentUrl } from "../lib/urls";
import { useExecutionById, useStepExecutions } from "./useStepExecutions";

export function useSelectedExecution(
  stepDir: string,
  workflowId: string,
  branchId: string
) {
  const { execution: urlExecutionId } = useCurrentUrl(routes.space.workflow);
  const { executions, loading } = useStepExecutions(
    workflowId,
    branchId,
    stepDir
  );
  const latest = executions[0];
  const inWindow = urlExecutionId
    ? executions.find((e) => e.id === urlExecutionId)
    : undefined;
  // A failure jump can target an execution older than the loaded window; fetch
  // it by id so the pane shows it instead of snapping back to the latest.
  const needsById = !!urlExecutionId && !inWindow;
  const { execution: byId, loading: byIdLoading } = useExecutionById(
    needsById ? urlExecutionId : undefined
  );
  // Only trust a by-id result that belongs to this step and branch; a stale
  // ?execution= carried over from another step must not render here.
  const byIdInStep =
    byId &&
    byId.workflowId === workflowId &&
    byId.branchId === branchId &&
    byId.stepDir === stepDir
      ? byId
      : undefined;
  const selected = inWindow
    ? inWindow
    : needsById
      ? (byIdInStep ?? (byIdLoading ? undefined : latest))
      : latest;
  return {
    selected,
    latest,
    latestId: latest?.id,
    loading: loading || (needsById && byIdLoading),
  };
}
